import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, of } from 'rxjs';

import { type CadastralAreaSuggestion } from '../models/valuation-request.model';
import {
  buildRuianQueryParams,
  mapRuianSuggestions,
  type RuianQueryResponse
} from '../utils/ruian-search.util';

@Injectable({ providedIn: 'root' })
export class CadastralAreaService {
  private readonly baseUrl = 'https://ags.cuzk.gov.cz/arcgis/rest/services/RUIAN/Prohlizeci_sluzba_nad_daty_RUIAN/MapServer/7/query';

  constructor(private readonly http: HttpClient) {}

  search(query: string): Observable<CadastralAreaSuggestion[]> {
    const normalizedQuery = query.trim();

    if (normalizedQuery.length < 2) {
      return of([]);
    }

    return this.http.get<RuianQueryResponse>(this.baseUrl, {
      params: buildRuianQueryParams(normalizedQuery)
    }).pipe(
      map((response) => mapRuianSuggestions<CadastralAreaSuggestion>(response.features))
    );
  }
}
